import React from 'react'

import {
    createRegisterableComponentWithData,
    EditionLoader,
} from '@news-mono/web-common'
import { SpecialEdition } from './SpecialEdition'

export interface NightlySpecialEditionRegistrationV2Props {
    lazyloadImages?: boolean
    shouldShowAllEditions?: boolean
    allEditionsLink?: string
    heading?: string
}

export const NightlySpecialEditionRegistration =
    createRegisterableComponentWithData(
        'nightly-special-edition',
        EditionLoader,

        (
            { ...props }: NightlySpecialEditionRegistrationV2Props,
            data,
            services,
        ) => {
            if (!data.loaded) return null

            const edition = data.result.documents?.[0]
            if (!edition) {
                services?.log?.error(data, 'NightlyLatestEdition: empty result')
                return null
            }

            if (!edition.primaryTopic) {
                services?.log?.error(
                    data,
                    'NightlyLatestEdition: missing primaryTopic',
                )
                return null
            }

            return (
                <SpecialEdition
                    edition={edition}
                    heading={props.heading}
                    lazyloadImages={props.lazyloadImages}
                    shouldShowAllEditions={props.shouldShowAllEditions}
                    allEditionsLink={props.allEditionsLink}
                    onEvent={services.onEvent}
                />
            )
        },
    )
